<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">备案地点</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">备案地点</div>
      </div>
      <div class="panel-body">
        <div class="beian-map ub-box" v-loading="listLoading">
          <div class="beian-left-map">
            <p class="gff8 z-margin-left-20-precent">
              *&nbsp;觉得幕布使用一次闲置浪费嘛？快来参与三丰云幕布分享计划吧，为您周围需要备案的朋
              <br>
              &nbsp;&nbsp;&nbsp;友提供拍照便利。
              在
              <router-link to="/beian3" class="z-color-a">快递材料</router-link>
              里分享您购买的幕布。
            </p>
            <p class="gff8 z-margin-left-20-precent" style="margin-top:5px">
              *&nbsp;所有分享点均属个人意愿，与三丰云无关,请客户去拍照之前，务必先电话确认下地址、
              <br>
              &nbsp;&nbsp;&nbsp;是否收费，并约定好拍照时间。
            </p>
            <div class="rulemap">
              <p class="gff8 z-margin-left-20-precent">*&nbsp;请选择下方地图中的省份,根据城市查询当地备案点和幕布分享点</p>
              <div class="rulemap" id="china-map"></div>
            </div>
          </div>
          <div class="beian-right-txt z-margin-left-20-precent">
            <xmap-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo"></xmap-city>
            <div class="rulelistbox z-margin-top-25-precent">
              <div v-for="(item, index) in dataInfo">
                <p class="rulelist-tit">备案地点{{index+1}}
                  <span class="gff8 z-font-size-14">（请提前预约，仅采集照片，不办理业务。）</span>
                </p>
                <ul class="rulelist-ul">
                  <li>&nbsp;单位名称：{{item.c_name}}</li>
                  <li>&nbsp;通讯地址：{{item.address}}</li>
                  <li>&nbsp;联&nbsp;&nbsp;系&nbsp;人：{{item.linkman}}</li>
                  <li>&nbsp;联系电话：&nbsp;{{item.mobile}}</li>
                  <li>&nbsp;工作时间：{{item.work_time}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import XmapCity from 'components/commons/XmapCity.vue'
  import beianService from 'business/beianService.js'
  import userService from 'business/userService.js'
  import {mapGetters,mapActions} from 'vuex'
  // 主模块
  import echarts from 'echarts/lib/echarts'
  // 地图
  import 'echarts/lib/chart/map'
  // 提示框
  import 'echarts/lib/component/tooltip'
  // 中国地图
  import 'echarts/map/js/china'
  export default {
    data() {
      return {
        listLoading:false,
        DISTRICTS:[],
        province:[],
        cityInfo: {
          province:'中国',
          city:'北京',
          area:'北京市'
        },
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 1
        },
        dataInfo:[]
      }
    },
    components:{
      XmapCity
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.config()
    },
    computed: {
      city() {
        return this.cityInfo.city
      },
    },
    watch:{
      cityInfo(){
        this.SearchInfo()
      },
      city(newValue){
        this.province.map(item => {
          item.selected = false
          if(newValue == item.name){
            item.selected = true
          }
        })
        let chinaMap = echarts.init(document.getElementById('china-map'))
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}'
          },
          series: [
            {
              name: '中国',
              type: 'map',
              mapType: 'china',
              zoom:1.2,
              selectedMode : 'single',
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: true
                }
              },
              data:this.province,
              itemStyle: {
                // 地图背景色
                normal: {
                  areaColor: '#AAD5F5',
                  borderColor: '#FEFEFF'
                },
                // 悬浮时
                emphasis: {
                  areaColor: '#0095EF'
                }
              },
            }
          ],
        };
        chinaMap.setOption(option);
      }
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async config() {
        this.SearchInfo()
        await this.getArea()
        let chinaMap = echarts.init(document.getElementById('china-map'))
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}'
          },
          series: [
            {
              name: '中国',
              type: 'map',
              mapType: 'china',
              zoom:1.2,
              selectedMode : 'single',
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: true
                }
              },
              data:this.province,
              itemStyle: {
                // 地图背景色
                normal: {
                  areaColor: '#AAD5F5',
                  borderColor: '#FEFEFF'
                },
                // 悬浮时
                emphasis: {
                  areaColor: '#0095EF'
                }
              },
            }
          ],
        };
        chinaMap.setOption(option);
        let that = this
        chinaMap.on('click',function (params) {
          if(params.name != ''){
            that.cityInfo.city = params.name;
          }
        })
      },
      async getArea() {
        this.listLoading = true
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=area_dic')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData
          this.province = vueData[0].province.map(item => {
            return{
              name:item.area_title,
              value:item.area_id,
              selected:false
            }
          })
          this.listLoading = false
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
      async SearchInfo() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_title == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].area_id)
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_title == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].area_id)
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_title == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].area_id)
                  }
                }
              }
            }
          }
        }
        let data = 'cmd=all_fenxiang'+
          '&province_id='+ this.cityId.cityid +
          '&city_id=' + this.cityId.districtid
        let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST',data)
        if(vueData.response == 200 ) {
          this.dataInfo = vueData.msg
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .beian-map {
    margin-top: 65px;
  }
  .beian-left-map {
    width: 700px;
  }
  .rulemap {
    width: 700px;
    min-height: 580px;
  }
  .beian-right-txt {
    width: 460px;
  }
  .rulelistbox {
    height: 525px;
    overflow-y: scroll;
  }
  .rulelist-tit {
    background: url(../../assets/imgs/img23.png) no-repeat left center;
    font-size: 14px;
    padding-left: 20px;
  }
  .rulelist-ul li {
    font-size: 14px;
    color: #888;
    margin-top: 6px;
    letter-spacing: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian4.vue